/**
 * Format quantity based on unit
 * If unit is "g" (grams), show as whole number
 * Otherwise, show with 3 decimal places
 * @param {number} quantity - The quantity to format
 * @param {string} unit - The unit (e.g., "g", "kg", "ml", "piece")
 * @returns {string} Formatted quantity string
 */
export const formatQuantity = (quantity, unit) => {
  const qty = parseFloat(quantity || 0);
  
  // If unit is "g" (grams), show as whole number
  if (unit && unit.toLowerCase() === "g") {
    return Math.round(qty).toString();
  }
  
  // For other units, show with 3 decimal places but remove trailing zeros
  const formatted = qty.toFixed(3);
  return parseFloat(formatted).toString();
};

/**
 * Format quantity with unit
 * @param {number} quantity - The quantity to format
 * @param {string} unit - The unit
 * @returns {string} Formatted quantity with unit (e.g., "200g" or "1.5kg")
 */
export const formatQuantityWithUnit = (quantity, unit) => {
  const formattedQty = formatQuantity(quantity, unit);
  return unit ? `${formattedQty} ${unit}` : formattedQty;
};

/**
 * Format order quantity display with detailed breakdown
 * @param {number} orderQuantity - Number of units ordered
 * @param {number} productQuantity - Quantity per tier/unit
 * @param {number} totalQuantity - Total quantity
 * @param {string} unit - The unit
 * @returns {string} Formatted quantity string (e.g., "3 × 200g = 600g")
 */
export const formatDetailedQuantity = (orderQuantity, productQuantity, totalQuantity, unit) => {
  const formattedOrderQty = formatQuantity(orderQuantity, unit);
  const formattedProductQty = formatQuantity(productQuantity, unit);
  const formattedTotalQty = formatQuantity(totalQuantity, unit);
  
  return `${formattedOrderQty} × ${formattedProductQty} ${unit || ""} = ${formattedTotalQty} ${unit || ""}`.trim();
};

